// extracted by mini-css-extract-plugin
export default {"main":"app_main__7lx0T","modal90w":"app_modal90w__kAQnj","spinner":"app_spinner__Wztjp"};